import { type PageBase, getCurrentPage, isComponentType } from '@avensia/excite';
import { pageToDataLayerInfo } from '../utils';
import { addToDataLayer, type DataLayerEvent } from '..';

export type SearchEventType = {
  usedSuggestion: boolean;
  usedHistory: boolean;
  searchPhrase: string;
  originalSearch: string;
};

export function addSearchEventToDataLayer(data: SearchEventType) {
  let defaultCategory = 'products';
  let interactionValue = 'direct_search';
  if (data.usedSuggestion) {
    interactionValue = 'suggestions';
    if (data.usedHistory) interactionValue = 'previously_searched';
  }

  let articleResultsCount = 0;
  let collectionResultsCount = 0;
  let brandResultsCount = 0;
  let productResultsCount = 0;
  let sortOptionsResults = 'not_available';
  let originalSearchTerm = '';
  const page = getCurrentPage() as PageBase;
  if (isComponentType<NordicNest.Api.SearchPageApiModel>(page)) {
    const { totalBrandHits, totalCollectionHits, articlePageCount, sortOptions, pagination, originalSearch } = page;

    if (pagination.total < 1) {
      defaultCategory = 'articles';
      if (articlePageCount < 1) {
        defaultCategory = 'brands';
        if (totalBrandHits < 1) {
          defaultCategory = 'collections';
          if (totalCollectionHits < 1) {
            defaultCategory = 'not_found';
          }
        }
      }
    }

    articleResultsCount = articlePageCount;
    collectionResultsCount = totalCollectionHits;
    brandResultsCount = totalBrandHits;
    productResultsCount = pagination.total;
    sortOptionsResults = sortOptions[0].value;
    originalSearchTerm = originalSearch;
  }

  // if we are redirected to a product page from search
  if (!isComponentType<NordicNest.Api.SearchPageApiModel>(page)) {
    productResultsCount = 1;
    originalSearchTerm = data.searchPhrase;
  }

  const ga4Event: DataLayerEvent = {
    event: 'search_result',
    event_info: {
      ...pageToDataLayerInfo(page),
      search_interaction: !data.usedSuggestion ? 'manual_search' : 'auto_search',
      search_interaction_type: interactionValue,
      search_interaction_value: data.searchPhrase,
      search_term: originalSearchTerm,
      search_result_default_sort_option: sortOptionsResults,
      search_result_default_category: defaultCategory,
      search_result_total_products: productResultsCount,
      search_result_total_collections: collectionResultsCount,
      search_result_total_brands: brandResultsCount,
      search_result_total_inspirations: articleResultsCount,
    },
  };
  delete ga4Event.event_info?.item_id; // item_id is not relevant for search events
  addToDataLayer(ga4Event);
}
